<template>
  <LessonContent :title="lesson.title" :order="lesson.order">

     <form-wizard class="mt-3 lesson-wizard"  color="black" errorColor="rgba(var(--vs-danger), 1)" backButtonText="<" title="" subtitle="" nextButtonText=">" :finishButtonText="buttonTitle">

      <tab-content title="">
        <LessonTabContent>
              <span class="font-black text-6xl">{{lesson.title | capitalize_1}}</span>

            <div class="lesson-intro-image-wrapper">
               <img class="mx-auto p-4 lesson-intro-image" src="@/assets/images/academy/academy_popup_6.svg"/>
           </div>

        </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>

          <p>
           In order to adopt a habit into your life, you need a routine that <span class="font-semibold">reminds you to do "it"</span>.

          </p>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>

             <div class="w-1/2 mx-auto">
                <img src="@/assets/images/academy/aca_20.png"/>
            </div>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p>
            And simply put, after a few or many iterations, you will start to perform the routine automatically → <span class="font-semibold">a habit is born.</span>
          </p>
       </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
          <p class="font-italic">
            Not all routines are habits, but all habits are routines.
          </p>

      <div class="w-1/3 mx-auto mt-4">
                <img src="@/assets/images/academy/aca_21.png"/>
            </div>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p>
            You will definitely build habits, but you have the choice whether you choose those habits or your autopilot will do it for you.
          </p>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>

          <p class="">
            To create habits that actually stick, it would be helpful if you understood the habit loop introduced by <span class="font-italic">Charles Duhigg.</span>

          </p>
       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p>
            The habit loop explains the process of habit formation consisting of three steps:
          </p>

            <div class="w-1/2 mx-auto mt-4">
              <img src="@/assets/images/academy/aca_23.png"/>
            </div>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p class="font-semibold text-4xl">The cue </p>
          <p class="mt-2">
            A trigger that alerts your brain to go into auto mode to perform a routine.
          </p>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <!-- <p class="text-4xl">The cue </p> -->

          <p class="">
            Common triggers are the time of day, a specific location, your phone buzzing, friends or family members, certain emotions <span class="font-italic mt-2">or seeing a routine inside improvee.io.</span></p>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p class="font-semibold text-4xl">The routine</p>
          <p class="mt-2">
            Automatic behavior that gets triggered by a cue. It’s the physical or mental action taken because of the cue. This is the action itself.
          </p>
       </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
          <p class="">
           For example you drink a cup of coffee; you grab your phone and start scrolling.

          </p>
       </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
          <p class="font-semibold text-4xl">The reward</p>
          <p class="mt-2">
            The benefit you get from the routine. <span class="font-semibold"> Rewards make the brain happy</span>, which is positive reinforcement and encouragement to continue the habit pattern and repeat it over and over.
          </p>
       </LessonTabContent>
      </tab-content>

<!--  -->

      <tab-content title="">
        <LessonTabContent>

          <p class="">
            This is the reason why it's usually hard to adopt healthy routines because there is no immediately visible reward. Conversely, unhealthy routines have an immediate reward.
          </p>


          <p class="mt-4 text-xl">
            For example you feel energized thanks to the caffeine; your addicted dopamine system is happy.
          </p>
 <!--          <p class="mt-2">
            This part is the breaking point for healthy routines, it's the reason why it's usually hard to adopt healthy routines because there is <span class="font-semibold">no immediately visible reward.</span>
          </p> -->
       </LessonTabContent>
      </tab-content>



      <tab-content title="">
        <LessonTabContent>
            <div class="w-1/2 mx-auto">
              <img src="@/assets/images/academy/aca_22.png"/>
            </div>
       </LessonTabContent>
      </tab-content>



      <tab-content title="" :beforeChange="saveAndExit">
        <LessonTabContent>
          <p>
            So, do you have any new ideas regarding your routines?
          </p>

          <div class="mt-2">
            <vs-button color="#5222D0" size="large" @click="redirectToActionBoard">check my routines</vs-button>
          </div>
       </LessonTabContent>
      </tab-content>

    </form-wizard>
  </LessonContent>

</template>

<script>
import LessonContent from './LessonContent'
import LessonTabContent from './LessonTabContent'
import { FormWizard, TabContent } from 'vue-form-wizard'
import LessonMixin from '../../Generic/LessonMixin'

export default {
  components: {
    LessonContent,
    LessonTabContent,
    TabContent,
    FormWizard
  },
  props: ['lesson'],
  mixins: [LessonMixin],
  data () {
    return {}
  },
  computed: {
  },
  methods: {
    redirectToActionBoard () {
      const routeData = this.$router.resolve({ name: 'planner' })
      window.open(routeData.href, '_blank')
    }
  },
}
</script>
